import React from 'react';

const variants = {
  text: 'h-4 w-full rounded',
  card: 'h-32 w-full rounded-xl',
  'table-row': 'h-10 w-full rounded',
  chart: 'h-64 w-full rounded-xl',
  circle: 'rounded-full',
  custom: '',
};

export default function Skeleton({
  variant = 'text',
  width,
  height,
  className = '',
  count = 1,
}) {
  const baseClass = 'bg-gray-200 dark:bg-gray-700 animate-pulse';

  const getStyle = () => {
    const style = {};
    if (width) style.width = typeof width === 'number' ? `${width}px` : width;
    if (height) style.height = typeof height === 'number' ? `${height}px` : height;
    return style;
  };

  const elements = Array.from({ length: count }, (_, i) => (
    <div
      key={i}
      className={`${baseClass} ${variants[variant] || variants.text} ${variant === 'circle' ? 'aspect-square' : ''} ${className}`}
      style={getStyle()}
    />
  ));

  if (count === 1) return elements[0];

  return (
    <div className="flex flex-col gap-2">
      {elements}
    </div>
  );
}
